import { render, staticRenderFns } from "./JdsDatum.vue?vue&type=template&id=760bcd70&scoped=true&"
import script from "./JdsDatum.vue?vue&type=script&lang=ts&"
export * from "./JdsDatum.vue?vue&type=script&lang=ts&"
import style0 from "./JdsDatum.vue?vue&type=style&index=0&id=760bcd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760bcd70",
  null
  
)

export default component.exports